export default "__VITE_ASSET__CWrO1p0J__"